import "../../../packages/@okta/courage-dist/esm/src/CourageForSigninWidget.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/framework/Model.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/vendor/lib/backbone.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js";
import oktaUnderscore from "../../../packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js";
import "../../../packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/models/Model.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/models/BaseModel.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/framework/View.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/views/Backbone.ListView.js";
import { FORMS, AUTHENTICATOR_KEY, IDP_FORM_TYPE } from "./RemediationConstants.js";
/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
const isObject = (x) => oktaUnderscore.isObject(x);
const isError = (response) => !!response.messages;
const getFirstLevelObjects = (resp) => {
  const result = {};
  oktaUnderscore.each(resp, (val = {}, key) => {
    if (key === "remediation") {
      return;
    }
    if (val.type === "array") {
      result[key] = {
        value: val.value
      };
    }
    if (val.type === "object") {
      result[key] = val.value;
    }
  });
  return result;
};
const getRemediationValues = (idx) => {
  const remediationValues = [];
  const hasSkipRemediationOnly = idx.neededToProceed.length === 1 && idx.neededToProceed[0].name === "skip";
  if (oktaUnderscore.isEmpty(idx.neededToProceed) || hasSkipRemediationOnly) {
    if (idx.context.success) {
      remediationValues.push({
        name: idx.context.success.name,
        href: idx.context.success.href,
        value: []
      });
    } else if (idx.context.messages) {
      remediationValues.push({
        name: FORMS.TERMINAL,
        // Using `value` is unnecessary as `messages` will be display via `TerminalView.showMessages`,
        // even though might sound a little counterintuitive.
        // The reason being is there is `BaseForm.showMessages` that is intended to handle
        // messages generically.
        value: []
      });
    } else if (idx.context.deviceEnrollment) {
      remediationValues.push({
        name: FORMS.DEVICE_ENROLLMENT_TERMINAL,
        value: []
      });
    }
  }
  return {
    remediations: [...remediationValues, ...idx.neededToProceed]
  };
};
const injectIdPConfigButtonToRemediation = (settings, idxResp) => {
  const widgetRemedations = idxResp.remediations;
  const hasIdentifyRemedation = widgetRemedations.filter((r) => r.name === "identify");
  if (hasIdentifyRemedation.length === 0) {
    return idxResp;
  }
  const idpsConfig = settings.get("idps");
  if (Array.isArray(idpsConfig)) {
    const existsRedirectIdpIds = {};
    widgetRemedations.forEach((r) => {
      if (r.name === FORMS.REDIRECT_IDP && r.idp) {
        existsRedirectIdpIds[r.idp.id] = true;
      }
    });
    const baseUrl = settings.get("baseUrl");
    const stateHandle = idxResp.idx.context.stateHandle;
    const redirectIdpRemedations = idpsConfig.filter((c) => !existsRedirectIdpIds[c.id]).map((idpConfig) => {
      const idp = {
        id: idpConfig.id,
        name: idpConfig.text
      };
      const redirectUri = `${baseUrl}/sso/idps/${idpConfig.id}?stateToken=${stateHandle}`;
      if (idpConfig.className) {
        idp.className = idpConfig.className;
      }
      return {
        name: FORMS.REDIRECT_IDP,
        type: idpConfig.type,
        idp,
        href: redirectUri
      };
    });
    idxResp.remediations = widgetRemedations.concat(redirectIdpRemedations);
  }
  return idxResp;
};
const convertRedirectIdPToSuccessRedirectIffOneIdp = (settings, result, lastResult) => {
  if (Array.isArray(result.remediations)) {
    const redirectIdpRemediations = result.remediations.filter((idp) => idp.name === FORMS.REDIRECT_IDP);
    if (redirectIdpRemediations.length !== 1 || result.remediations.length !== 1) {
      return;
    }
    const isDirectAuth = settings.get("oauth2Enabled");
    if (isDirectAuth && !lastResult) {
      return;
    }
    const successRedirect = {
      name: FORMS.SUCCESS_REDIRECT,
      href: redirectIdpRemediations[0].href,
      value: []
    };
    result.remediations = [successRedirect];
  }
};
const modifyFormNameForIdP = (result) => {
  if (Array.isArray(result.remediations)) {
    result.remediations.forEach((remediation) => {
      var _remediation$relatesT, _remediation$relatesT2;
      if (remediation.name === FORMS.REDIRECT_IDP && (remediation === null || remediation === void 0 ? void 0 : (_remediation$relatesT = remediation.relatesTo) === null || _remediation$relatesT === void 0 ? void 0 : (_remediation$relatesT2 = _remediation$relatesT.value) === null || _remediation$relatesT2 === void 0 ? void 0 : _remediation$relatesT2.key) === AUTHENTICATOR_KEY.IDP) {
        const isVerifyFlow = Object.prototype.hasOwnProperty.call(result, "currentAuthenticatorEnrollment");
        remediation.name = isVerifyFlow ? "challenge-authenticator" : "enroll-authenticator";
      }
      if (remediation.name === FORMS.REDIRECT_IDP && remediation.type === IDP_FORM_TYPE.X509) {
        remediation.name = FORMS.PIV_IDP;
      }
    });
  }
};
const isFailureRedirect = (result) => {
  const context = result.idx.context;
  return context.failure && context.failure.name === "failure-redirect";
};
const handleFailureRedirect = (settings, result) => {
  const context = result.idx.context;
  const isDirectAuth = settings.get("oauth2Enabled");
  const alwaysRedirect = settings.get("redirect") === "always";
  if (isDirectAuth && !alwaysRedirect) {
    return;
  }
  const failureRedirect = {
    name: FORMS.FAILURE_REDIRECT,
    href: context.failure.href,
    value: []
  };
  result.remediations = [failureRedirect];
};
const convert = (settings, idx = {}, lastResult = null) => {
  if (!isObject(idx.rawIdxState)) {
    return null;
  }
  const firstLevelObjects = getFirstLevelObjects(idx.rawIdxState);
  const remediationValues = getRemediationValues(idx);
  const result = Object.assign({}, firstLevelObjects, remediationValues, {
    idx
  });
  if (isError(result) && isFailureRedirect(result)) {
    handleFailureRedirect(settings, result);
  }
  injectIdPConfigButtonToRemediation(settings, result);
  modifyFormNameForIdP(result);
  if (!isError(result)) {
    convertRedirectIdPToSuccessRedirectIffOneIdp(settings, result, lastResult);
  }
  return result;
};
export { convert as default };
